@if ({
    saleUpdates:(saleUpdates$ | async)
}; as data) {

        <div class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col"
             [ngClass]="newUi()
                ? 'tw-box-border tw-gap-1 tw-rounded-[20px] tw-border tw-border-solid tw-border-[color:var(--sys-cashregister-cart-group-bg)] tw-bg-[var(--sys-card)] tw-p-1'
                : 'tw-contents'">
            <!--HEADER-->
            <app-active-sale-header-info-wrapper [sale]="data.saleUpdates?.currentSale" [isPaymentsState]="isPaymentsState"/>

            <!--SHOP_CART/PAYMENT_LIST-->
            <div #shopCart class="tw-overflow-y-hidden tw-flex-1"
                 [ngClass]="newUi() ? 'tw-rounded-xl' : 'tw-border-solid tw-border tw-border-gray-200 tw-rounded-lg'">
                @if(isPaymentsState){
                    <app-payments-list-wrapper [sale]="data.saleUpdates?.currentSale"/>
                } @else {
                    <app-shop-cart-wrapper [saleUpdates]="data.saleUpdates!"/>
                }
            </div>
        </div>

        <!--BOTTOM_BUTTONS-->
        @if(isPaymentsState && data.saleUpdates?.currentSale){
            <app-payments-action-buttons [sale]="data.saleUpdates?.currentSale"/>
        } @else if(data.saleUpdates?.currentSale || (!isPaymentsState && sideKeyboard())){
             <app-active-sale-action-buttons-wrapper/>
        }
}
